import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue, useSetRecoilState} from 'recoil';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {Button, Stack, Toolbar, Typography, alpha} from '@mui/material';

import {assignableServiceRequestsState} from '../../../../store/service-requests/atoms';
import {totalServiceRequestsToAssign} from '../../../../store/service-requests/selectors';

export const TableToolbar: FC = () => {
  const setAssignable = useSetRecoilState(assignableServiceRequestsState);
  const total = useRecoilValue(totalServiceRequestsToAssign);
  const navigate = useNavigate();

  const resetAssignable = () => {
    setAssignable({0: []});
  };

  return (
    <Toolbar
      sx={{
        minHeight: '48px !important',
        pl: {sm: 2},
        pr: {xs: 1, sm: 1},
        justifyContent: 'space-between',
        ...(total > 0 && {
          bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {total ? (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography color="inherit" variant="subtitle1" component="div">
            {`Выбрано: ${total}`}
          </Typography>
          <Button startIcon={<RestartAltIcon />} onClick={resetAssignable} color="primary">
            Сбросить
          </Button>
        </Stack>
      ) : (
        <Button startIcon={<KeyboardReturnIcon />} onClick={() => navigate('/serviceRequests')}>
          Назад
        </Button>
      )}
    </Toolbar>
  );
};
